import { Select, MenuItem, InputLabel, FormControl, TextField, IconButton, Grid, FormHelperText } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useFormikContext } from "formik";
import { getFieldList } from "./utils/getFieldList";
import { logicalOperatorRules } from "../../../../../constants";

const Condition = ({ requiredFieldsList, sectionList, index, conditionIndex, deleteCondition }) => {
  const { values, handleChange, handleBlur, errors, setFieldValue } = useFormikContext();
  const {
    subSectionList,
    targetFieldList: sourceFieldList,
    hasSubSection,
  } = getFieldList({
    requiredFieldsList,
    section: values.conditionalFields[index].conditions[conditionIndex].section,
    subSection: values.conditionalFields[index].conditions[conditionIndex].subSection,
  });
  const isRuleValueRequired =
    values.conditionalFields[index].conditions[conditionIndex].rule !== "is_empty" &&
    values.conditionalFields[index].conditions[conditionIndex].rule !== "is_not_empty";

  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid item xs={hasSubSection ? 2.2 : 2.75}>
        <FormControl fullWidth error={!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.section}>
          <InputLabel size="small" htmlFor={`conditionalFields.${index}.conditions.${conditionIndex}.section`}>
            Section
          </InputLabel>
          <Select
            labelId={`conditionalFields.${index}.conditions.${conditionIndex}.section`}
            label="Section"
            size="small"
            name={`conditionalFields.${index}.conditions.${conditionIndex}.section`}
            value={values.conditionalFields[index].conditions[conditionIndex].section}
            onChange={(e) => {
              handleChange(e);
              // Reset subSection and sourceField when section changes.
              setFieldValue(`conditionalFields.${index}.conditions.${conditionIndex}.subSection`, "self");
              setFieldValue(`conditionalFields.${index}.conditions.${conditionIndex}.sourceField`, undefined);
            }}
            onBlur={handleBlur}
            inputProps={{
              id: `conditionalFields.${index}.conditions.${conditionIndex}.section`,
            }}
          >
            {sectionList.map((section) => (
              <MenuItem value={section} key={section}>
                {section}
              </MenuItem>
            ))}
          </Select>
          {!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.section && (
            <FormHelperText>{errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.section}</FormHelperText>
          )}
        </FormControl>
      </Grid>
      {hasSubSection && (
        <Grid item xs={2.2}>
          <FormControl fullWidth error={!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.subSection}>
            <InputLabel size="small" htmlFor={`conditionalFields.${index}.conditions.${conditionIndex}.subSection`}>
              Sub Section
            </InputLabel>
            <Select
              labelId={`conditionalFields.${index}.conditions.${conditionIndex}.subSection`}
              label="Sub Section"
              size="small"
              name={`conditionalFields.${index}.conditions.${conditionIndex}.subSection`}
              value={values.conditionalFields[index].conditions[conditionIndex].subSection}
              onChange={handleChange}
              onBlur={handleBlur}
              inputProps={{
                id: `conditionalFields.${index}.conditions.${conditionIndex}.subSection`,
              }}
            >
              {subSectionList.map((subSection) => (
                <MenuItem value={subSection} key={subSection}>
                  {subSection}
                </MenuItem>
              ))}
            </Select>
            {!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.subSection && (
              <FormHelperText>
                {errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.subSection}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
      )}
      <Grid item xs={hasSubSection ? 2.2 : 2.75}>
        <FormControl fullWidth error={!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.sourceField}>
          <InputLabel size="small" htmlFor={`conditionalFields.${index}.conditions.${conditionIndex}.sourceField`}>
            Source Field
          </InputLabel>
          <Select
            labelId={`conditionalFields.${index}.conditions.${conditionIndex}.sourceField`}
            label="Source Field"
            size="small"
            name={`conditionalFields.${index}.conditions.${conditionIndex}.sourceField`}
            value={values.conditionalFields[index].conditions[conditionIndex].sourceField}
            onChange={handleChange}
            onBlur={handleBlur}
            inputProps={{
              id: `conditionalFields.${index}.conditions.${conditionIndex}.sourceField`,
            }}
          >
            {sourceFieldList.map((sourceField) => (
              <MenuItem value={sourceField} key={sourceField}>
                {sourceField}
              </MenuItem>
            ))}
          </Select>
          {!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.sourceField && (
            <FormHelperText>
              {errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.sourceField}
            </FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={hasSubSection ? 2.2 : 2.75}>
        <FormControl fullWidth error={!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.rule}>
          <InputLabel size="small" htmlFor={`conditionalFields.${index}.conditions.${conditionIndex}.rule`}>
            Rule
          </InputLabel>
          <Select
            labelId={`conditionalFields.${index}.conditions.${conditionIndex}.rule`}
            label="Rule"
            size="small"
            name={`conditionalFields.${index}.conditions.${conditionIndex}.rule`}
            value={values.conditionalFields[index].conditions[conditionIndex].rule}
            onChange={(e) => {
              handleChange(e);
              // Reset ruleValue when rule changes.
              setFieldValue(`conditionalFields.${index}.conditions.${conditionIndex}.ruleValue`, undefined);
            }}
            onBlur={handleBlur}
            inputProps={{
              id: `conditionalFields.${index}.conditions.${conditionIndex}.rule`,
            }}
          >
            {logicalOperatorRules.map((rule) => (
              <MenuItem value={rule} key={rule}>
                {rule}
              </MenuItem>
            ))}
          </Select>
          {!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.rule && (
            <FormHelperText>{errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.rule}</FormHelperText>
          )}
        </FormControl>
      </Grid>
      {isRuleValueRequired && (
        <Grid item xs={hasSubSection ? 2.2 : 2.75}>
          <FormControl fullWidth error={!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.ruleValue}>
            <TextField
              variant="outlined"
              label="Value"
              size="small"
              id={`conditionalFields.${index}.conditions.${conditionIndex}.ruleValue`}
              name={`conditionalFields.${index}.conditions.${conditionIndex}.ruleValue`}
              value={values.conditionalFields[index].conditions[conditionIndex].ruleValue}
              onChange={handleChange}
              onBlur={handleBlur}
              error={!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.ruleValue}
            />
            {!!errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.ruleValue && (
              <FormHelperText>
                {errors?.conditionalFields?.[index]?.conditions?.[conditionIndex]?.ruleValue}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
      )}
      <Grid item size={1}>
        <IconButton color="primary" onClick={() => deleteCondition()} size="small">
          <ClearIcon fontSize="small" />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export { Condition };
